module.exports = __webpack_public_path__ + "img/howto01.5e29c457.jpg";